<template>
  <el-main class="container">
    <Nav>
        <div
            slot="left"
            class="left">
            <el-input
                v-model.trim="body.word"
                clearable
                class="input-text"
                maxlength="30"
                placeholder="请输入企业名称/房号进行搜索"/>
            <el-button type="primary" @click="event().search()">搜索</el-button>
            <!-- <div class="select-build">
                <el-select
                    slot="prepend"
                    v-model="selectFloor"
                    class="select"
                    placeholder="选择楼层"
                    @change="event().selectFn($event)">
                    <el-option
                        v-for="(item,index) in floor"
                        :key="index"
                        :value="item"></el-option>
                </el-select>
            </div> -->
            <div class="select-build">
              <span>产业筛选</span>
              <el-select v-model="selectIndustry" @change="handleIndustry()" clearable>
                <el-option
                  v-for="item in industryList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
        </div>
        <div class="right" slot="right">
            <!-- <el-button
                type="primary"
                class="excel"
                @click="network().updata()">
                一键同步</el-button> -->
            <el-button
                v-show="hasAuthority('companyExcel')"
                type="primary"
                class="excel"
                @click="network().getCompanyExcel()">
                导出Excel</el-button>
        </div>
    </Nav>
    <table-pagination
        ref="table"
        :config="config"
        :datasource="datasource"
        :idRow="idRow"
        :width='100'
        class="table"
        @change-page="handlerPageChange"
        @change-page-num="handlerPageNum">
        <el-table-column
            slot="action"
            fixed="right"
            label="操作"
            width="300"
            align="center">
            <template slot-scope="scope">
            <div class="table-row">
                <span v-show="hasAuthority('companyApprover')" @click="handlerGo('approver',scope)">设置审批人</span>
                <span v-show="hasAuthority('companyDetail')" @click="handlerGo('details',scope)">查看详情</span>
                <span v-show="hasAuthority('companyVisit')" @click="handlerGo('visit',scope)">访客记录</span>
                <span v-show="hasAuthority('companyRelease')" @click="handlerGo('pass',scope)">放行记录</span>
            </div>
            <div>
              <el-link v-show="hasAuthority('companyDiscount')" type="primary" :underline="false" @click="handlerDiscount(scope)">设置折扣</el-link>
            </div>
            </template>
        </el-table-column>
    </table-pagination>
    <el-dialog
        :visible.sync="showApplyDialog"
        width="1000px">
        <div class="apply-box">
            <div class="title">
            <div>设置审批人</div>
            <div>（企业审批人停车券发放权利）</div>
            </div>
            <div class="search-box">
              <el-input class="input" clearable v-model="inputUserVal" placeholder="请输入姓名/手机号进行搜索"></el-input>
              <el-button class="btn" type="primary" @click="event().searchUser()">搜索</el-button>
            </div>
            <table-pagination
                ref="table"
                :config="config1"
                :datasource="applyUserInfo"
                @selection-change='handlerSetApply'
                :selectBoxIndex="selectBoxIndex"
                :defaultPage="defaultPage"
                :checkBox="true"
                class="table1"
                @change-page-num="handlerPageNum1"
                @change-page="handlerPageChange1">
                <el-table-column
                    slot="action"
                    fixed="right"
                    label="认证状态"
                    width="200"
                    align="center">
                    <template slot-scope="scope">
                        <div class="status">
                        <el-link
                          type="primary"
                          :underline="true"
                          @click="event().showDialog(scope.row)">
                        {{ scope.row.isAuthentication | status }}</el-link>
                        </div>
                    </template>
                </el-table-column>
            </table-pagination>
            <div class="btn">
              <el-button @click="event().return()">返回</el-button>
              <el-button type="primary" @click="event().setApply()">设为审批人</el-button>
            </div>
        </div>
    </el-dialog>
    <el-dialog
      :visible.sync="dialogVisible"
      :show-close="false"
      :close-on-click-modal="false"
      width="20%"
    >
      <div class="dialog-title">设置折扣</div>
      <div class="input-box">
        <el-input placeholder="请输入折扣" class="input" v-model="discountBody.discount"></el-input><div>%</div>
      </div>
      <div class="btn-box">
        <el-button @click="handleClose">取消</el-button>
        <el-button type="primary" @click="handleSetDiscount">确定</el-button>
      </div>
    </el-dialog>

    <el-dialog
      :visible.sync="showUserDialog"
      width="500px">
      <div class="user-info-box">
        <div class="title">
          <span>用户信息</span>
        </div>
        <div class="row">
          <span>头像：</span>
          <span><img :src="userInfo.wxAvatar" alt=""></span>
        </div>
        <div class="row">
          <span>昵称：</span>
          <span>{{userInfo.wxName }}</span>
        </div>
        <!-- <div class="row">
          <span>手机号：</span>
          <span>{{userInfo.mobile }}</span>
        </div> -->
        <div class="row">
          <span>工号：</span>
          <span>{{userInfo.jobNum }}</span>
        </div>
        <div class="row">
          <span>真实姓名：</span>
          <span>{{userInfo.name }}</span>
        </div>
        <div class="row">
          <span>所属企业：</span>
          <span>{{userInfo.enterpriseName }}</span>
        </div>
        <div class="row">
          <span>注册时间：</span>
          <span>{{userInfo.createTime }}</span>
        </div>
        <el-button type="primary" class="btn" @click="event().userDetails()">查看详情</el-button>
      </div>
    </el-dialog>
  </el-main>
</template>

<script>
import utils from '@/jslib/utils'
import Nav from '@/components/nav'
import TablePagination from '@/components/table-pagination'
import { getCompanyList, getCompanyExcel, setDiscount, updata, getCompanyUserList, getCompanyDetails, getCompanyUserDetails, setApply } from '@/api/company'
import { mapMutations } from 'vuex'
import { getIndustrySelectList } from '@/api/industry'
export default {
  name: "CompanyList",
  data() {
    return {
      showUserDialog: false,
      body: {
        word: '',
        floor: '',
        pageSize: 10,
        pageIndex: 1,
        industryUuid: ''
      },
      companyUserBody: {
        uuid: '',
        status: 1,
        pageSize: 5,
        pageIndex: 1,
        word: ''
      },
      companyBody: {
        uuid: ''
      },
      putApplyBody: { // 设置审批人put请求所需参数
        uuid: '',
        uuidList: []
      },
      excelBody: {
        floor: '',
        word: ''
      },
      info: [], // 公司详情信息
      config: {
        size: 10,
        fields: [
          {
            prop: 'industryName',
            label: '所在产业'
          },
          {
            prop: 'name',
            label: '企业名称'
          },
          {
            prop: 'floor',
            label: '楼层'
          },
          {
            prop: 'roomNo',
            label: '房号'
          },
          {
            prop: 'discount',
            label: '折扣',
            type: 'discount'
          },
          {
            prop: 'status',
            label: '状态',
            type: 'status',
            rule: [
              {
                value: 1,
                label: '正常'
              },
              {
                value: 2,
                label: '已退租'
              }
            ]
          }
        ]
      },
      config1: {
        size: 5,
        fields: [
          {
            prop: 'jobNum',
            label: '工号'
          },
          {
            prop: 'name',
            label: '姓名'
          },
          {
            prop: 'mobile',
            label: '手机号'
          }
        ]
      },
      datasource: {
        total: 0,
        data: []
      },
      applyUserInfo: { // 已认证审批人信息
        total: 0,
        data: []
      },
      selectApply: [], // 所选表格信息
      selectBoxIndex: [], // 已经是审批人得序号
      floor: {},
      selectFloor: '',
      idRow: true,
      showApplyDialog: false,
      status: false,
      defaultPage: 1,
      industryList: [],
      selectIndustry: '',
      dialogVisible: false,
      discountBody: {
        discount: 0,
        uuid: ''
      },
      userInfo: {},
      //微信用户uuid
      Wxuuid: '',
      //审批人搜索
      inputUserVal: ''
    }
  },
  filters: {
    status: function(val) {
      if (val === 0) {
        return `未认证`
      } else return '已认证'
    }
  },
  async created() {
    await this.network().getIndustrySelectList()
    if(this.$route.query.id){
      this.selectIndustry = JSON.parse(this.$route.query.id)
      this.body.industryUuid = JSON.parse(this.$route.query.id)
    }
    await this.network().getCompanyList()
    // await this.network().getFloorList()
  },
  methods: {
    event() {
      return {
        search: () => {
          this.network().getCompanyList()
        },
        selectFn: (e) => {
          if (e === '选择楼层') this.body.floor = ''
          else this.body.floor = this.selectFloor
          this.network().getCompanyList()
        },
        setApply: () => {
          if(this.applyUserInfo.data.length === 0){
            this.$message.error('没有人员')
            return
          }
          this.putApplyBody.uuidList = []
          if (this.selectApply.length > 2) {
            this.$message.error('审批人数量超过两人')
            return
          }
          if (this.selectApply.length > 0) { // 如果勾选有值就设置为审批人如果勾选有值就设置为审批人
            this.selectApply.forEach((item, index) => {
              this.putApplyBody.uuidList.push(item.uuid)
            })
          } else { // 没勾选任何人就用默认审批人
            this.putApplyBody.uuidList = this.info.reviewList.uuid
          }
          this.putApplyBody.uuid = this.companyBody.uuid
          this.putApplyBody.uuidList = [...new Set(this.putApplyBody.uuidList)]// 去重
          this.network().setApply()
        },
        return: () => {
          this.showApplyDialog = false
          this.selectBoxIndex = []// 清空勾选状态
          this.$refs.table.cleanSelection()// 调用子组件清空勾选状态。
        },
        showDialog:(row)=>{
          this.network().getCompanyUserDetails(row.uuid)
          this.Wxuuid = row.userUuid
          this.showUserDialog = true
        },
        userDetails:() => {
          this.$router.push({ path: `/user-management/user-details/get/${this.Wxuuid}`, query: { userUuid: this.Wxuuid }})
        },
        searchUser:()=>{
          this.companyUserBody.word = this.inputUserVal
          this.companyUserBody.pageIndex = 1
          this.network().getCompanyUserList()
        }
      }
    },
    network() {
      return {
        getCompanyList: async() => {
          const { data } = await getCompanyList(this.body)
          data.list.forEach((item, index) => {
            if (item.status === 2) {
              item.color = 'company'
            }
          })
          this.datasource.total = data.total
          this.datasource.data = data.list
        },
        getCompanyExcel: async() => {
          this.excelBody.floor = this.body.floor
          this.excelBody.word = this.body.word
          const { data } = await getCompanyExcel(this.excelBody)
          utils.exportExcel(data, '企业列表')
        },
        // getFloorList: async() => {
        //   const { data } = await getFloorList()
        //   this.floor = data
        //   this.floor.unshift('选择楼层')
        // },
        updata: async() => {
          await updata()
          this.$message({
            type: 'success',
            message: '成功'
          })
          this.network().getCompanyList()
          // this.network().getFloorList()
        },
        getCompanyUserList: async() => {
          const { data } = await getCompanyUserList(this.companyUserBody)
          this.applyUserInfo.data = data.list
          this.applyUserInfo.total = data.total
          this.applyUserInfo.data.forEach((item, index) => {
            this.info.reviewList.forEach((item1, index1) => {
              if (item1.uuid === item.uuid) {
                const str = {
                  toggle: false,
                  index: index,
                  uuid: item1.uuid
                }
                this.selectBoxIndex.push(str)
              }
            })
          })
          // 数组对象去重，存入一个uuid方便去重，存一个toggle用于处理默认勾选
          const obj = []
          this.selectBoxIndex = this.selectBoxIndex.reduce((item, next) => {
            obj[next.uuid] ? '' : obj[next.uuid] = true && item.push(next)
            return item
          }, [])
          this.$nextTick(() => {
            this.showApplyDialog = true
          })
        },
        getIndustrySelectList: async() => {
          const { data } = await getIndustrySelectList()
          data.forEach(item => {
            this.industryList.push({
              value: item.uuid,
              label: item.name
            })
          })
        },
        getCompanyDetails: async() => {
          const { data } = await getCompanyDetails(this.companyBody.uuid)// 获取
          this.info = data
          this.network().getCompanyUserList()
        },
        setApply: async() => {
          await setApply(this.putApplyBody)
          this.$message({
            message: '成功',
            type: 'success'
          })
          this.showApplyDialog = false
          this.selectBoxIndex = []// 清空勾选状态
          this.$refs.table.cleanSelection()// 调用子组件清空勾选状态。
        },
        setDiscount: async() => {
          await setDiscount(this.discountBody)
          this.$message({
            message: '设置成功',
            type: 'success'
          })
          this.dialogVisible = false
          this.network().getCompanyList()
        },
        // 员工详细信息
        getCompanyUserDetails: async(uuid) => {
          const { data } = await getCompanyUserDetails(uuid)
          this.userInfo = data
        },
      }
    },
    handlerGo(name, scope) {
      switch (name) {
        case 'visit' : // 访客记录
          this.$router.push({
            path: `company-management/company-visit/get/${scope.row.uuid}`,
            query: {
              info: JSON.stringify(scope.row),
              type: 'company'
            }
          })
          break
        case 'details' : // 查看详情
          this.$router.push({
            path: `company-management/company-details/get/${scope.row.uuid}`,
            query: { index: scope.$index }
          })
          break
        case 'approver': // 设置审批人
          this.applyUserInfo.data = []
          this.applyUserInfo.total = 0
          this.selectApply = []
          this.companyUserBody.pageIndex = 1
          this.companyUserBody.uuid = scope.row.uuid
          this.companyBody.uuid = scope.row.uuid
          this.network().getCompanyDetails()
          break
        case 'pass': // 放行记录
          this.$router.push({
            path: `/company-management/release-log/get/${scope.row.uuid}`
          })
          break
      }
    },
    handlerSetApply(data) {
      this.selectApply = data
    },
    handlerPageChange(data) {
      this.body.pageIndex = data.page
      this.network().getCompanyList()
    },
    handlerPageNum(data){
      this.body.pageIndex = 1
      this.body.pageSize = data.pageNum
      this.network().getCompanyList()
    },
    handlerPageChange1(data) {
      debugger
      this.companyUserBody.pageIndex = data.page
      this.showApplyDialog = false
      this.network().getCompanyUserList()
    },
    handlerPageNum1(data) {
      this.companyUserBody.pageIndex = 1
      this.companyUserBody.pageSize = data.pageNum
      this.network().getCompanyUserList()
    },
    handleIndustry() {
      this.body.industryUuid = this.selectIndustry
      this.body.pageIndex = 1
      this.network().getCompanyList()
    },
    handlerDiscount(scoped) {
      this.discountBody.uuid = scoped.row.uuid
      this.discountBody.discount = scoped.row.discount
      this.dialogVisible = true
    },
    handleClose() {
      this.dialogVisible = false
    },
    handleSetDiscount() {
      if (Number(this.discount) < 0 || Number(this.discount) > 100) {
        this.$message.error('请输入正确折扣')
      } else {
        this.body.discount = this.discountBody.discount
        this.network().setDiscount()
      }
    },
    ...mapMutations(['storeBoxSelect'])
  },
  components: {
    Nav,
    TablePagination
  }
}
</script>

<style scoped lang="scss">
.container{
    .select-build{
        margin-left: 60px;
        display: flex;
        align-items: center;
        span{
            margin-right: 15px;
        }
        .select{
            width: 120px;
            text-align: center;
        }
    }

    .table-row{
        width: 75%;
        margin: 0 auto;
        display: flex;
        justify-content: center;
        flex-flow: row wrap;
        span{
            margin: 0 10px;
            color: rgb(85, 156, 223);
            cursor: pointer;
        }
    }

    .apply-box{
        .title{
            font-weight: bold;
            text-align: center;
            div{
            &:nth-child(1){
                margin-top: -40px;
            }
            &:nth-child(2){
                margin-bottom: 30px;
            }
            }
        }
        .btn{
            display: flex;
            justify-content: center;
            margin-top: 60px;
            button{
            width: 150px;
            }
        }
    }

  /deep/.el-dialog{
    // border-radius: 15px;
    /deep/.el-dialog__header {
      // padding: 0;
    }

    .dialog-title{
      font-size: 20px;
      font-weight: bold;
    }

    .input-box{
      display: flex;
      align-items: center;
      margin: 40px 0;
      .input {
        width: 300px;
        margin-right: 10px;
      }
    }
    .btn-box{
      display: flex;
      justify-content: center;
    }
  }
  .user-info-box{
    display: flex;
    flex-direction: column;
    .title{
      text-align: center;
      font-weight: bold;
      margin: -40px 0 30px 0;
      font-size: 20px;
    }
    .row{
      display: flex;
      align-items: center;
      margin: 30px 0;
      span{
        &:nth-child(1){
          width: 120px;
          color: rgb(184, 180, 180);
        }
        &:nth-child(2){
          color: #000;
        }
      }
      img{
        width: 70px;
        border-radius: 50%;
      }
    }
    .btn{
      margin: 30px auto;
      width: 50%;
    }
  }
  .apply-box{
    .search-box{
      display: flex;
      align-items: center;
      margin-bottom: 30px;
      .input{
        width: 300px;
      }
      .btn{
        margin: 0;
        margin-left: 15px;
      }
    }
  }
}
</style>
